// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "51417" ? "__federation_expose_MyAccountDrawer" : chunkId) + ".css"
}